import request from "../request";
import qs from 'qs'
import CryptoJs from 'crypto-js'
import {NODE_API} from '../../config'
    export const saveLogin=(params)=>{
        if(params.loginUser) params.loginUser = trims(params.loginUser)
        if(params.loginPwd) params.loginPwd = CryptoJs.MD5(trims(params.loginPwd)).toString()
        const data = qs.stringify(params)
        return request({
            url: NODE_API + '/users/login',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        })
    }
    export const saveLogout=(params)=>{
        return request({
            url: NODE_API + '/users/logout',
            method: 'post',
        })
    }
    
